import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Boxes, Search } from "lucide-react";

export default function Inventory() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/warehouse/inventory").then(({ data }) => setItems(data));
  }, []);

  const filtered = items.filter((i) =>
    (i.sku || "").toLowerCase().includes(q.toLowerCase()) ||
    (i.name || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="warehouse-inventory">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black flex items-center gap-2">
          <Boxes className="w-7 h-7 text-primary" /> Inventory
        </h1>
        <p className="text-muted-foreground">Live stock per SKU with warehouse-wise breakdown.</p>
      </div>

      <div className="surface-card p-4">
        <div className="flex items-center gap-2 mb-3 max-w-md">
          <Search className="w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Search SKU or name…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            data-testid="inv-search"
          />
        </div>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>SKU</TableHead>
                <TableHead>Name</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Unit</TableHead>
                <TableHead className="text-right">On hand</TableHead>
                <TableHead className="text-right">Reorder</TableHead>
                <TableHead>Locations</TableHead>
                <TableHead>Health</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filtered.map((i) => (
                <TableRow key={i.item_id} data-testid={`inv-row-${i.sku}`}>
                  <TableCell className="font-mono text-xs">{i.sku}</TableCell>
                  <TableCell className="font-medium">{i.name}</TableCell>
                  <TableCell><Badge variant="outline">{i.item_type}</Badge></TableCell>
                  <TableCell>{i.unit}</TableCell>
                  <TableCell className="text-right font-mono">{i.total_qty}</TableCell>
                  <TableCell className="text-right font-mono text-muted-foreground">{i.reorder_level}</TableCell>
                  <TableCell className="text-xs">
                    {i.locations?.length
                      ? i.locations.map((l) => `${l.warehouse_name}: ${l.quantity}`).join(", ")
                      : "—"}
                  </TableCell>
                  <TableCell>
                    {i.below_reorder ? (
                      <Badge variant="destructive">Below reorder</Badge>
                    ) : (
                      <Badge className="bg-emerald-600 hover:bg-emerald-700">Healthy</Badge>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {filtered.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} className="text-center text-muted-foreground py-10">
                    No items match your search.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
